import { useState, useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";

export default function AnimatedCounter({ end, suffix = "", prefix = "", label, duration = 2000, variant = "light" }) {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (inView && !hasAnimated.current) {
      hasAnimated.current = true;
      let start = 0;
      const step = end / (duration / 16);
      const timer = setInterval(() => {
        start += step;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [inView, end, duration]);

  const isDark = variant === "dark";

  return (
    <div ref={ref} data-testid="animated-counter" className="text-center">
      <div
        className={`text-4xl sm:text-5xl lg:text-6xl font-bold mb-2 ${isDark ? "text-[#d4af37]" : "text-[#111]"}`}
        style={{ fontFamily: 'var(--font-display)' }}
      >
        {prefix}{count}{suffix}
      </div>
      {label && (
        <p className={`text-sm sm:text-base ${isDark ? "text-white/60" : "text-[#555]"}`} style={{ fontFamily: 'var(--font-sans)' }}>
          {label}
        </p>
      )}
    </div>
  );
}
